import LessonListContainer from './LessonListContainer';

export default LessonListContainer;
